import Common from '../common'
import { registerModule } from '@/store'
import { NAMESPACE_SELF_PHOTO } from './config'
export default {
  path: '/selfphoto',
  component: Common,
  beforeEnter: async (to, from, next) => {
    const { StoreModule } = await import('./store')
    if (StoreModule) {
      registerModule(NAMESPACE_SELF_PHOTO, StoreModule)
    }
    next()
  },
  children: [
    {
      //自营摄影预约
      path: 'add-reserve',
      name: 'add-reserve',
      component: () => import('./add-reserve')
    },
    {
      //自营摄影我的相册
      path: 'my-album',
      name: 'my-album',
      component: () => import('./my-album')
    },
    {
      //自营摄影相册分享
      path: 'share-album',
      name: 'share-album',
      component: () => import('./share-album')
    }
  ]
}
